module.exports = __webpack_public_path__ + "img/4-3.40e9dbbb.svg";